import * as CPL from '@teamsparta/cross-platform-logger';

export const sendLog = (action: string, data = {}) => {
  try {
    CPL.sendCPLog(action, data);
  } catch (error) {
    console.error(error);
  }
};
